import { createContext } from 'react'
type props = {
  colour: { hex: string | null } | null
  isLight: boolean | null
  codeId: string | null
} | null

export const ColorContext = createContext<props>(null)
